<template>
  <div class="event-detail">
    <div class="content">
      <LD v-if="EventDetail.integration == 'ld'" />
      <Facecast v-if="EventDetail.integration == 'fc'" />
      <Iframe v-if="EventDetail.integration == 'iframe'" />
      <div class="event-detail__title" v-html="EventDetail.name"></div>
      <div class="event-detail__program" v-if="EventDetail.programme.length">
        <div class="event-detail__program-title">Расписание</div>
        <div
          class="event-detail__program-item"
          v-for="(item, ind) in EventDetail.programme"
          :key="ind"
        >
          <input type="checkbox" :id="`program_${ind}`" />
          <label
            :for="`program_${ind}`"
            class="event-detail__program-item-head"
          >
            <div class="event-detail__program-item-info">
              <div class="event-detail__program-item-time">
                {{ item.start }}
                –
                {{ item.end }}
              </div>
              <div
                class="event-detail__program-item-title"
                v-html="item.title"
              ></div>
            </div>
            <div class="event-detail__program-item-arrow">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 6.5L12 17.5L22.5 6.5"
                  stroke="black"
                  stroke-width="2"
                />
              </svg>
            </div>
          </label>
          <div class="event-detail__program-item-body">
            <div class="event-detail__program-item-body-row">
              <div class="event-detail__program-item-time" style="opacity: 0">
                {{ item.start }}
                –
                {{ item.end }}
              </div>
              <div class="event-detail__program-item-lectors">
                <div
                  class="event-detail__program-item-lector"
                  v-for="(lector, ind) in item.lectors"
                  :key="ind"
                >
                  <div class="event-detail__program-item-lector-img">
                    <img v-if="lector.photo" :src="lector.photo" />
                  </div>
                  <div class="event-detail__program-item-lector-text">
                    <div class="event-detail__program-item-lector-name">
                      {{ lector.name }}
                    </div>
                    <div class="event-detail__program-item-lector-position">
                      {{ lector.position }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="event-detail__about" v-if="EventDetail.description">
        <div class="event-detail__about-title">О мероприятии</div>
        <div
          class="event-detail__about-text"
          v-html="EventDetail.description"
        ></div>
      </div>
      <div class="event-detail__lectors" v-if="EventDetail.lectors.length">
        <div class="event-detail__lectors-head">
          <div class="event-detail__lectors-title">Ведущие</div>
          <div class="event-detail__lectors-arrows">
            <div
              class="event-detail__lectors-arrow event-detail__lectors-arrow_prev"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 2L5 11.5L16 21"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </div>
            <div
              class="event-detail__lectors-arrow event-detail__lectors-arrow_next"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 22L19 12.5L8 3"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="event-detail__lectors-swiper-container">
          <swiper class="event-detail__lectors-swiper" v-bind="swiperSettings">
            <swiper-slide
              class="event-detail__lectors-swiper-slide"
              v-for="(lector, ind) in EventDetail.lectors"
              :key="ind"
            >
              <div class="event-detail__lectors-item">
                <div class="event-detail__lectors-item-img">
                  <img v-if="lector.photo" :src="lector.photo" />
                </div>
                <div class="event-detail__lectors-item-name">
                  {{ lector.name }}
                </div>
                <div
                  v-if="lector.position"
                  class="event-detail__lectors-item-position"
                >
                  {{ lector.position }}
                </div>
                <div v-if="lector.tag" class="event-detail__lectors-item-tag">
                  {{ lector.tag }}
                </div>
              </div>
            </swiper-slide></swiper
          >
        </div>
      </div>
      <div class="event-detail__materials" v-if="EventDetail.materials.length">
        <div class="event-detail__materials-title">Полезные материалы</div>
        <div class="event-detail__materials-row">
          <div
            class="event-detail__materials-material"
            v-for="(m, ind) in EventDetail.materials"
            :key="ind"
          >
            <div
              class="event-detail__materials-material-title"
              v-html="m.title"
            ></div>
            <a
              :href="m.file || m.url"
              v-html="m.btn_text || 'Скачать'"
              download
              target="_blank"
              class="event-detail__materials-material-button button button_pink"
            >
            </a>
          </div>
        </div>
      </div>
      <div class="event-detail__shorts" v-if="EventDetail.additional_info">
        <div class="event-detail__shorts-title">Список сокращений</div>
        <div
          class="event-detail__shorts-text"
          v-html="EventDetail.additional_info"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "swiper/swiper-bundle.css";
import { Navigation } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import LD from "@/components/main/events/LD.vue";
import Facecast from "@/components/main/events/Facecast.vue";
import Iframe from "@/components/main/events/Iframe.vue";
SwiperCore.use([Navigation]);
export default {
  metaInfo() {
    if (this.EventDetail.name) {
      return {
        title: "Az-most - " + this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
      };
    } else {
      return { title: "Az-most - " + this.EventDetail.name };
    }
  },
  name: "EventDetailLive",
  components: { Error, Swiper, SwiperSlide, LD, Facecast, Iframe },
  data: () => ({
    socket: null,
    swiperSettings: {
      slidesPerView: 3,
      spaceBetween: 32,
      loop: false,
      navigation: {
        nextEl: ".event-detail__lectors-arrow_next",
        prevEl: ".event-detail__lectors-arrow_prev",
      },
      breakpoints: {
        320: {
          slidesPerView: "auto",
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1220: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    },
  }),
  computed: {
    ...mapGetters(["EventDetail", "user", "IframeAccess"]),
  },
  methods: {
    createSocket() {
      let socket = new WebSocket(
        `${
          process.env.VUE_APP_WEBSOCKET_HOST || ""
        }/ws/analytics?token=${localStorage.getItem("token")}&event_id=${
          this.EventDetail.id
        }&event_type=event_live_visit&session_id=${
          this.$root.analyticData.session_id
        }`
      );
      this.$set(this, "socket", socket);
      window.onbeforeunload = () => {
        this.socket.close();
        window.onbeforeunload = null;
      };
      socket.onopen = (e) => {
        this.socketOnOpen(e);
      };

      socket.onmessage = (e) => {
        this.socketOnMessage(e);
      };

      socket.onclose = (e) => {
        this.socketOnClose(e);
      };

      socket.onerror = (e) => {
        this.socketOnError(e);
      };
    },
    socketOnOpen(e) {
      this.socket.send(
        JSON.stringify({
          brand_name: this.EventDetail.brands.map((el) => el.title).join(", "),
          brand_id: this.EventDetail.brands.map((el) => el.brand_id).join(", "),
          content_date: this.EventDetail.date,
          content_id: this.EventDetail.id,
          content_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          content_type: "Мероприятие",
          nosology_name: this.EventDetail.disease
            .map((el) => el.title)
            .join(", "),
          content_parameter: "",
          event_type: "live_visit",
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          page_type: "Мероприятие",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        })
      );
    },
    socketOnMessage(e) {
      const m = JSON.parse(e.data);
      if (m && m.type == "ping") {
        this.socket.send(JSON.stringify({ type: "pong" }));
      }
    },
    socketOnClose(e) {},
    socketOnError(e) {},
  },
  created() {
    this.createSocket();
  },
  beforeDestroy() {
    window.onbeforeunload = null;
    this.socket.close();
  },
};
</script>

<style lang="scss" scoped>
.event-detail {
  padding-top: 32px;
  &__title {
    margin-top: 32px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 53px;
    color: #000000;
    @media screen and (max-width: 767px) {
      font-size: 16px;
      text-align: center;
      line-height: 24px;
    }
  }

  &__about {
    margin-top: 52px;
    padding: 24px 32px;
    background-color: #f8f8f8;
    border-radius: 30px;
    @media screen and (max-width: 767px) {
      margin-top: 28px;
      padding: 24px;
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;
      @media screen and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-text {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #000000;
    }
  }

  &__program {
    margin-top: 52px;
    @media screen and (max-width: 767px) {
      margin-top: 28px;
    }
    &-title {
      margin-bottom: 40px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;
      @media screen and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-item {
      border-bottom: 1px solid #dadada;
      &:not(:last-child) {
        margin-bottom: 32px;
      }

      & input {
        display: none;

        &:checked {
          & ~ .event-detail__program-item-head {
            .event-detail__program-item {
              &-arrow {
                transform: rotate(180deg);
              }
            }
          }

          & ~ .event-detail__program-item-body {
            max-height: max-content;
            padding-bottom: 32px;
          }
        }
      }

      &-head {
        margin-bottom: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        @media screen and (max-width: 767px) {
          align-items: flex-start;
        }
      }

      &-info {
        margin-right: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 767px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      &-time {
        padding: 16px 24px;
        background-color: #818181;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        color: #ffffff;
        border-radius: 99px;
        margin-right: 24px;
        flex-shrink: 0;
        @media screen and (max-width: 767px) {
          padding: 8px 24px;
          margin-bottom: 16px;
          margin-right: 0;
        }
      }

      &-title {
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #000000;
      }

      &-arrow {
        margin-left: auto;
        transition: 0.3s;
      }

      &-body {
        max-height: 0;
        overflow: hidden;
        &-row {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
        }

        & .event-detail__program-item-time {
          opacity: 0;
          @media screen and (max-width: 767px) {
            display: none;
          }
        }
      }

      &-lector {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        &:not(:last-child) {
          margin-bottom: 32px;
        }

        &-img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          overflow: hidden;
          flex-shrink: 0;
          margin-right: 16px;

          & img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }
        }

        &-name {
          margin-bottom: 8px;
          font-family: "Roboto Slab", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 26px;
          color: #000000;
        }

        &-position {
          font-family: "Roboto", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          color: #7b7b7b;
        }
      }
    }
  }

  &__lectors {
    margin-top: 52px;
    padding: 24px 32px;
    background-color: #f8f8f8;
    border-radius: 30px;
    @media screen and (max-width: 767px) {
      margin-top: 28px;
      padding: 24px;
    }

    &-head {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 32px;
      @media screen and (max-width: 767px) {
        margin-bottom: 24px;
      }
    }

    &-title {
      margin-right: 16px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;
      @media screen and (max-width: 767px) {
        font-size: 24px;
      }
    }

    &-arrows {
      margin-left: auto;
      gap: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-arrow {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #d9d9d9;
      color: #fff;
      transition: 0.3s;
      cursor: pointer;

      &.swiper-button-disabled {
        pointer-events: none;
      }

      @media screen and (min-width: 1220px) {
        &:hover {
          background-color: #830051;
        }
      }
    }

    &-item {
      &-img {
        margin-bottom: 32px;
        width: 100%;
        aspect-ratio: 1/ 1;
        border-radius: 30px;
        overflow: hidden;

        & img {
          width: 100%;
          height: auto;
        }
      }

      &-name {
        margin-bottom: 16px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        color: #000000;
      }

      &-position {
        margin-bottom: 16px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #7b7b7b;
      }

      &-tag {
        width: fit-content;
        border-radius: 99px;
        padding: 4px 12px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        background-color: #0067b2;
      }
    }

    &-swiper {
      &-slide {
        @media screen and (max-width: 767px) {
          width: 70%;
        }
      }
    }
  }

  &__materials {
    margin-top: 52px;
    padding: 24px 32px;
    background-color: #f8f8f8;
    border-radius: 30px;

    @media screen and (max-width: 767px) {
      margin-top: 28px;
      padding: 24px;
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;
      @media screen and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
      @media screen and (max-width: 1220px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media screen and (max-width: 767px) {
        grid-template-columns: 100%;
      }
    }

    &-material {
      padding: 30px;
      height: 100%;
      background-color: #fff;
      border-radius: 30px;
      display: flex;
      flex-direction: column;

      &-title {
        margin-bottom: 24px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        color: #000000;
      }

      &-button {
        width: 100%;
        margin-top: auto;
        @media screen and (max-width: 1220px) {
          width: fit-content;
        }
      }
    }
  }

  &__shorts {
    margin-top: 52px;
    @media screen and (max-width: 1220px) {
      margin-top: 28px;
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;
      @media screen and (max-width: 1220px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-text {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #000000;
    }
  }
}
</style>